module.exports = __webpack_public_path__ + "static/img/marketing-sms.49aac85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marketing/marketing-sms.png
// module id = gqU+
// module chunks = 2